import { render, staticRenderFns } from "./reviews-boxer.vue?vue&type=template&id=0ab51808&scoped=true&"
import script from "./reviews-boxer.vue?vue&type=script&lang=js&"
export * from "./reviews-boxer.vue?vue&type=script&lang=js&"
import style0 from "./reviews-boxer.vue?vue&type=style&index=0&id=0ab51808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab51808",
  null
  
)

export default component.exports